import styles from './HighlightedText.module.scss';
import React from 'react';

export type HighlightedTextProps = {
  highlightColor: 'green' | 'blue';
  text: string;
};

export const HighlightedText = (props: HighlightedTextProps) => {
  function getExtraStyle(): any {
    switch (props.highlightColor) {
      case 'blue':
        return styles.highlightedBlue;
      default:
        return styles.highlightedGreen;
    }
  }

  return <mark className={`${styles.highlightedShape} ${getExtraStyle()}`}>{props.text}</mark>;
};
